import {
  Component,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

export interface LegendItem {
  abbr: string;
  full: string;
}

@Component({
  selector: 'stupa-table-legend-overlay',
  standalone: true,
  imports: [CommonModule, OverlayPanelModule],
  templateUrl: './table-legend-overlay.component.html',
  styleUrl: './table-legend-overlay.component.scss',
  /** None so the overlay-panel (appended to <body>) picks up our scoped styles. */
  encapsulation: ViewEncapsulation.None,
})
export class TableLegendOverlayComponent {
  @Input() items: LegendItem[] = [];

  @ViewChild('panel') private readonly panel!: OverlayPanel;

  /** Call from parent template: <th (click)="legendOverlay.toggle($event)"> */
  toggle(event: Event): void {
    this.panel.toggle(event);
  }
}
